import {API_URL} from '../../../../resources/api';

export const rankURL : string = `${API_URL}dashboard/food/rank`;
export const winLosesURL : string = `${API_URL}dashboard/food/winloses`;
export const chefmetURL : string = `${API_URL}dashboard/food/chefmet`;
